import { render, staticRenderFns } from "./NavRoot.vue?vue&type=template&id=0929d2b2&"
import script from "./NavRoot.vue?vue&type=script&lang=js&"
export * from "./NavRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports